'use es6';

import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { useTestVariationDropdownButtonProps } from 'ContentEditorUI/hooks/useTestVariationDropdownButtonProps';
import { Text } from 'foundations-components/components/Text';
import ABTestManagerModal from 'page-editor-ui/containers/ABTestManagerModal';
import { TestVariationTourSecondStep, useTestVariationApprovalTour } from './TestVariationTours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AbDropdownControls = ({
  abActiveVariantId,
  abMasterId,
  hasPermissionsToCreateOrEditABTest,
  isVariant,
  masterName,
  onClick,
  variantName
}) => {
  const [manageTestModalOpen, setManageTestModalOpen] = useState(false);
  const pageName = isVariant ? variantName : masterName;
  const dropdownButtonProps = useTestVariationDropdownButtonProps({
    pageName
  });
  const onManageTestClick = () => setManageTestModalOpen(true);
  const onManageTestModalClose = () => setManageTestModalOpen(false);
  const {
    goToStepTwo,
    endTour
  } = useTestVariationApprovalTour();
  const dropdown = /*#__PURE__*/_jsx(UIDropdown, Object.assign({}, dropdownButtonProps, {
    onOpenComplete: goToStepTwo,
    onOpenChange: ({
      target: {
        value: open
      }
    }) => {
      if (!open) {
        endTour();
      }
    },
    buttonUse: "form",
    children: /*#__PURE__*/_jsx(TestVariationTourSecondStep, {
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          active: !isVariant,
          onClick: () => onClick(abMasterId),
          "data-variation": "A",
          "data-variation-id": abMasterId,
          children: masterName
        }), /*#__PURE__*/_jsx(UIButton, {
          active: isVariant,
          onClick: () => onClick(abActiveVariantId),
          "data-variation": "B",
          "data-variation-id": abActiveVariantId,
          children: variantName
        }), hasPermissionsToCreateOrEditABTest && /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(UIButton, {
            use: "transparent",
            className: "p-x-5",
            onClick: onManageTestClick,
            children: /*#__PURE__*/_jsx(Text, {
              color: "fill-secondary-default",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "abDropdownControls.manageTest"
              })
            })
          })]
        })]
      })
    })
  }));
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "abDropdownControls.tooltip"
      }),
      placement: "bottom",
      children: dropdown
    }), manageTestModalOpen && /*#__PURE__*/_jsx(ABTestManagerModal, {
      onClose: onManageTestModalClose
    })]
  });
};
AbDropdownControls.propTypes = {
  abActiveVariantId: PropTypes.number.isRequired,
  abMasterId: PropTypes.number.isRequired,
  hasPermissionsToCreateOrEditABTest: PropTypes.bool.isRequired,
  isVariant: PropTypes.bool.isRequired,
  masterName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variantName: PropTypes.string.isRequired,
  renderPopover: PropTypes.func
};
export default AbDropdownControls;